import useSWR from "swr";
import apiClient, { apiClientEosNative } from "../../../apiClient";
import useUnit from "../../../customHooks/useUnit";
import moment from "moment";
import { DeviceWithWorkTime } from "../../../globals/interfaces";
import { formatMinutes, getMinutes, getTsDate } from "../../../utils";
import VirtualTable from "../../../components/custom/VirtualTable";
import Layout from "../../../components/custom/Layout";
import useLoading from "../../../customHooks/useLoading";
import { Nav, TabContent } from "reactstrap";
import CustomNavItem from "../../../components/custom/CustomNavItem";
import { useState } from "react";
import CustomTabPane from "../../../components/custom/CustomTabPane";
import Logs from "./Logs";

export type Tab = 'MANAGE' | 'LOGS';

const fetcher = async (endpoint: string): Promise<Array<DeviceWithWorkTime>> => {
    try {
        const res = await apiClient.get(endpoint);
        const data = res.data.map(item => ({
            ...item,
            duration: formatMinutes(getMinutes(item.startTime))
        }));
        return data;
    } catch (err) {
        return [];
    }
}


export default function ManageActiveDevices() {

    const unit = useUnit();
    const { setLoading } = useLoading();

    const {
        data,
        mutate
    } = useSWR(
        `/device/active-device-users?unit=${unit}&date=${moment().format('YYYY-MM-DD')}`,
        fetcher,
        {
            refreshInterval: 10000
        }
    );

    const [activeTab, setActiveTab] = useState<Tab>('MANAGE');
    const toggleTab = (tab: Tab) => setActiveTab(tab);

    const logoutUser = async (email: string, deviceId: string) => {
        try {
            setLoading(true);
            const res = await apiClientEosNative.post(`/user/lead-logout`, {
                email,
                time: getTsDate(),
                unit,
                signoutType: 'EOS LEAD',
                deviceId
            });
            mutate();
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="Truck Buildup"
                    tabId="MANAGE"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<Tab>
                    tabName="Logs"
                    tabId="LOGS"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'MANAGE'}>
                    <h6>Manage Active User Devices</h6>
                    <VirtualTable<DeviceWithWorkTime>
                        data={data}
                        mapping={[{
                            name: 'User',
                            value: 'email',
                            email: true
                        }, {
                            name: 'Device',
                            value: 'internalName',
                            largeWidth: true
                        }, {
                            name: 'EOS ID',
                            value: 'deviceName',
                            largeWidth: true
                        }, {
                            name: 'Active Since',
                            value: 'startTime',
                            utc: true,
                            datetime: true
                        }, {
                            name: 'Duration (Hours:minutes)',
                            value: 'duration',
                            number: true
                        }, {
                            name: 'Delete',
                            value: 'fa fa-trash text-danger',
                            icon: true,
                            function: (item) => logoutUser(item.email, item.deviceId)
                        }]}
                    />
                </CustomTabPane>
                <CustomTabPane<Tab> tabId={'LOGS'}>
                    <Logs 
                        tabId={activeTab}
                        unit={unit}
                    />
                </CustomTabPane>
            </TabContent>

        </Layout>
    );
}